import React from "react";
import "./NavBAr.css";
import NavLogo from "../../Assets/NavLogo.png";

function NavBar() {
  return (
    <div className="NavBar">
      <div className="N-left">
        <img className="N-img" src={NavLogo} />
      </div>
      <div className="N-right">
        <ul>
          <li>
            <a href="#"> HOME</a>
          </li>
          <li class="N-Dropdown">
          <a href="#" className="N-About">
              {" "}
              ABOUT US
            </a>
            <ul class="N-Dropdown-content">
              <li><a href="#">About STS</a></li>
              <li><a href="#">Vission & Mission</a></li>
              <li><a href="#">Objectives</a></li>
              <li><a href="#">Legal Structure</a></li>
              <li><a href="#">STS Team</a></li>
              <li><a href="#">Core Team & Policy</a></li>
            </ul>
          </li>
          <li>
            <a href="#" className="N-Test">
              {" "}
              TEST & PRODUCTS
            </a>
          </li>
          <li>
            <a href="#" className="N-Ser">
              {" "}
              SEVICES
            </a>
          </li>
          <li>
            <a href="#" className="N-Proj">
              {" "}
              ALL PROJECTS
            </a>
          </li>
          <li>
            <a href="#" className="N-Contact">
              {" "}
              CONTACT US
            </a>
          </li>
          <li className="Nav-Icon">
            <i className=" N-icon fa fa-search"></i>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default NavBar;
